<template>
    <div class="row justify-content-center">
        <div class="login-wrap">
            <template v-if="invalid">
                <div class="row mt-4">
                    <div class="col-md-12">
                        <div class="error-message alert alert-danger">{{ invalid }}</div>
                    </div>
                </div>
            </template>
            <template v-else>
                <form @submit.prevent="reset_password">
                    <div class="row">
                        <div class="col-md-12">
                            <h3>Enter new password</h3>
                            <div class="form-group">
                                <label>New Password</label>
                                <input type="password" class="form-control" placeholder="New Password" v-model="model.password" @keyup="validate_password" required>
                            </div>
                            <div class="form-group">
                                <label>Confirm New Password</label>
                                <input type="password" class="form-control" placeholder="Confirm New Password" v-model="model.password_confirmation" required>
                            </div>
                            <div v-for="(error, key) in errors.password" :key="key">
                                <div class="error-message alert alert-danger" v-if="key == 0">{{ error }}</div>
                            </div>
                            <div class="validation-wrap mt-2">
                                <div class="validation">
                                    <span v-if="password_validation.char_length" class="fa fa-check-circle"></span>
                                    <span v-else class="fa fa-circle"></span>
                                    Must be at least 8 characters in length
                                </div>
                                <div class="validation">
                                    <span v-if="password_validation.lowercase" class="fa fa-check-circle"></span>
                                    <span v-else class="fa fa-circle"></span>
                                    Must contain at least one lowercase letter
                                </div>
                                <div class="validation">
                                    <span v-if="password_validation.uppercase" class="fa fa-check-circle"></span>
                                    <span v-else class="fa fa-circle"></span>
                                    Must contain at least one uppercase letter
                                </div>
                                <div class="validation">
                                    <span v-if="password_validation.digit" class="fa fa-check-circle"></span>
                                    <span v-else class="fa fa-circle"></span>
                                    Must contain at least one digit
                                </div>
                                <div class="validation">
                                    <span v-if="password_validation.special_char" class="fa fa-check-circle"></span>
                                    <span v-else class="fa fa-circle"></span>
                                    Must contain a special character
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-4">
                        <div class="col-md-12">
                            <h3>Update Security Question</h3>
                            <div class="form-group">
                                <label>Security Question</label>
                                <select class="form-control" v-model="model.security_question" required>
                                    <option value="">- Select security question -</option>
                                    <option v-for="question in security_questions" :key="question.id" :value="question.id">{{ question.question }}</option>
                                </select>
                            </div>
                            <div class="error-message alert alert-danger" v-for="(error, key) in errors.security_question" :key="key">{{ error }}</div>
                            <div class="form-group">
                                <label>Security Answer</label>
                                <input type="text" class="form-control" placeholder="Your security answer" v-model="model.security_answer" required>
                            </div>
                            <div class="error-message alert alert-danger" v-for="(error, key) in errors.security_answer" :key="key">{{ error }}</div>
                        </div>
                    </div>
                    <div class="row mt-4" v-if="user.role == 'customer'">
                        <div class="col-md-12">
                            <h3>Update Field Account</h3>
                            <div class="form-group">
                                <label>Username: {{ model.field_account_username }}</label>
                            </div>
                            <div class="form-group">
                                <label>Email Address</label>
                                <input type="email" class="form-control" placeholder="Email Address" v-model="model.field_account_email" required>
                            </div>
                            <div class="error-message alert alert-danger" v-for="(error, key) in errors.field_account_email" :key="key">{{ error }}</div>
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-md-12 text-center">
                            <button type="submit" class="btn btn-primary btn-block" :disabled="isSubmitting">
                                <span v-if="isSubmitting">Please wait...</span>
                                <span v-else>Reset</span>
                            </button>
                        </div>
                    </div>
                </form>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isSubmitting: false,
            invalid: false,
            errors: [],
            security_questions: [],
            user: {},
            model: {
                username: '',
                token: '',
                password: '',
                password_confirmation: '',
                security_question: '',
                security_answer: '',
                field_account_id: '',
                field_account_username: '',
                field_account_email: ''
            },
            password_validation: {
                char_length: false,
                lowercase: false,
                uppercase: false,
                digit: false,
                special_char: false
            }
        }
    },
    mounted() {
        this.model.username = this.$route.params.username
        this.model.token = this.$route.params.token
        this.get_security_questions()
        this.check_reset_password_token()
        this.reset_password_user()
    },
    methods: {
        reset_password_user() {
            this.$http.post('/api/reset_password_user', { username: this.model.username })
                .then((res) => {
                    if(res.data.security_question) {
                        this.model.security_question = res.data.security_question
                    }
                    this.model.security_answer = res.data.security_answer
                    this.model.field_account_id = res.data.field_account.id
                    this.model.field_account_username = res.data.field_account.username
                    this.model.field_account_email = res.data.field_account.email
                    this.user = res.data.user
                })
        },
        check_reset_password_token() {
            this.$http.post('/api/check_reset_password_token', this.model)
                .then(() => {
                    this.invalid = false
                })
                .catch((error) => {
                    this.invalid = error.response.data.message
                })
        },
        get_security_questions() {
            this.$http.get('/api/security_questions')
                .then(response => {
                    this.security_questions = response.data.data
                })
        },
        reset_password() {
            this.isSubmitting = true
            this.errors = []

            this.$http.post('/api/reset_password', this.model)
                .then(() => {
                    localStorage.setItem('user', '')
                    localStorage.removeItem('need_reset');
                    window.location.href = '/login'
                })
                .catch((error) => {
                    this.isSubmitting = false
                    if(error.response.data.errors) {
                        this.errors = error.response.data.errors
                    }
                })
        },
        validate_password() {
            if(this.model.password.length >= 8) {
                this.password_validation.char_length = true
            } else {
                this.password_validation.char_length = false
            }

            if((/[a-z]/.test(this.model.password))) {
                this.password_validation.lowercase = true
            } else {
                this.password_validation.lowercase = false
            }

            if((/[A-Z]/.test(this.model.password))) {
                this.password_validation.uppercase = true
            } else {
                this.password_validation.uppercase = false
            }

            if((/[0-9]/.test(this.model.password))) {
                this.password_validation.digit = true
            } else {
                this.password_validation.digit = false
            }

            if((/[~`!@#$%^&*()\-_+={}[\]|\\:;"'<>,.?/]/.test(this.model.password))) {
                this.password_validation.special_char = true
            } else {
                this.password_validation.special_char = false
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.form-control {
    border: 1px solid #102e6c;
    border-radius: 4px;
    font-size: 13px;
    height: 47px;
    padding: 5px 10px;
    margin-bottom: 0.5em;
}
.btn-primary {
    padding: 12px 30px;
    width: 100%;
}
.error-message{
    color: #a94442;
    background-color: #f2dede;
    border-color: #ebccd1;
    padding: 10px 15px;
    margin-bottom: 8px;
    border: 1px solid transparent;
    border-radius: 4px;
}
.validation {
    color: #404040;
    .fa-check-circle {
        color: #459e45;
    }
    .fa-circle {
        color: #e6e6e6;
    }
}
</style>
